import { Badge, Button, Col, Row, Stack } from "react-bootstrap";
import { renderTrendIcon } from "../helperRenders";
import { BarChartLineFill } from "react-bootstrap-icons";

export default function HybridHitlistRow({ item, setTrendSong, setCatalogueSong, digital }) {
    return (
        <Row className={`py-1 border-bottom hoverable`} onClick={() => setCatalogueSong(item.song)}>
            <Col xs={3} xl={1} className=" align-content-center text-center fw-bold d-none d-xl-block">
                #{item.song_rank}
            </Col>
            <Col xl={2} className="d-none d-xl-flex align-items-center justify-content-center">
                {item.rank_trend == null ? (
                    <Badge bg="ra-yellow" style={{ width: 48 }} className="me-1 justify-content-center">
                        NEW
                    </Badge>
                ) : (
                    <>
                        <span className="d-flex me-1">{renderTrendIcon(Math.sign(item.rank_trend))}</span>
                        <span style={{ width: "3ch" }}>{Math.abs(item.rank_trend)}</span>
                    </>
                )}
                {!digital && (
                    <Button
                        className="d-flex column-gap-1 align-items-center"
                        variant="ra-yellow"
                        size="sm"
                        onClick={e => {
                            e.stopPropagation();
                            setTrendSong(item.song);
                        }}>
                        <BarChartLineFill size={16} />
                        <span className=" d-none d-xxl-inline-block">Trend</span>
                    </Button>
                )}
            </Col>
            <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                {item.song.artist}
            </Col>
            <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                {item.song.title}
            </Col>
            <Col xs={2} xl={2} className="align-content-center text-center d-none d-xl-block">
                {item.song.release_year}
            </Col>
            <Col xs={12} className=" d-xl-none ">
                <Stack direction="horizontal" gap={1}>
                    <span className="fw-bold fs-6">#{item.song_rank}</span>
                    {item.rank_trend == null ? (
                        <Badge className="me-1" bg="ra-yellow">
                            NEW
                        </Badge>
                    ) : (
                        <span className="d-flex me-1">{renderTrendIcon(Math.sign(item.rank_trend))}</span>
                    )}
                    <Button
                        className="d-flex column-gap-1 align-items-center"
                        variant="ra-yellow"
                        size="sm"
                        onClick={e => {
                            e.stopPropagation();
                            setTrendSong(item.song);
                        }}>
                        <BarChartLineFill size={16} />
                        <span>Trend</span>
                    </Button>
                </Stack>
                <Stack direction="horizontal" gap={1} className=" fw-bold flex-wrap">
                    <span>{item.song.artist}</span>
                    <span>-</span>
                    <span>{item.song.title}</span>
                    {item.song.release_year && <span>({item.song.release_year})</span>}
                </Stack>
            </Col>
            {!digital && (
                <>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                        <span className=" d-xl-none">Digital Rank: </span>
                        <span className=" fw-bold fw-xl-normal">{item.digital_rank == null ? "-" : `#${item.digital_rank}`}</span>
                    </Col>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center">
                        <span className=" d-xl-none">Airplay Rank: </span>
                        <span className=" fw-bold fw-xl-normal">{item.airplay_rank == null ? "-" : `#${item.airplay_rank}`}</span>
                    </Col>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center d-xl-none">
                        <span className=" d-xl-none">Trend: </span>
                        <span className=" fw-bold fw-xl-normal">{item.rank_trend ?? "-"}</span>
                    </Col>
                    <Col xs={"auto"} xl={1} className=" align-content-center text-center d-xl-none">
                        <span className=" d-xl-none">Previous Rank: </span>
                        <span className=" fw-bold fw-xl-normal">{item.previous_rank == null ? "-" : `#${item.previous_rank}`}</span>
                    </Col>
                </>
            )}
            <Col xs xl={1} className=" align-content-center text-center d-none d-xl-block">
                {item.previous_rank == null ? "-" : `#${item.previous_rank}`}
            </Col>
        </Row>
    );
}
